import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import { Icon } from '$common';
import style from './translate.scss';
import Cookies from 'js-cookie';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import EN from '$constants/translates/en/en.json';
import TR from '$constants/translates/tr/tr.json';
import AR from '$constants/translates/ar/ar.json';

const languages = {
  en: EN,
  tr: TR,
  ar: AR,
};
let languageList = {};
if (process.muhimma.indexOf(process.target[0]) !== -1) {
  languageList = {
    'en': 'English',
    'tr': 'Türkçe',
    'ar': 'لعَرَبِيَّة‎‎'
  }
} else {
  languageList = {
    'en': 'English',
    'tr': 'Türkçe'
  }
}

let browserLang = (navigator.language).substring(0, (navigator.language).indexOf('-'));

@CSSModules(style, { allowMultiple: true })
export default class Translate extends Component {

  constructor(props) {
    super(props);
    // Set default language
    this.state = {
      langKey: process.muhimma.indexOf(process.target[0]) !== -1 ? 'ar' : 'en'
    }
  }

  componentWillMount() {
    Cookies.set('BROWSER_LANG', process.muhimma.indexOf(process.target[0]) !== -1 ? 'ar' : browserLang || 'en' );

    if (Cookies.get('SELECTED_LANG')) {
      this.setState({langKey: Cookies.get('SELECTED_LANG')});
    }else{
      this.setState({langKey: Cookies.get('BROWSER_LANG')});
      Cookies.set('SELECTED_LANG', Cookies.get('BROWSER_LANG'));
    }

    if (Cookies.get('SELECTED_LANG') === 'ar') {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    }
  }

  switchLang(langCode){
    // window.Intercom('trackEvent', 'SWITCHED_LANGUAGE', { from_locale: Cookies.get('SELECTED_LANG'), to_locale: langCode });
    Cookies.set('SELECTED_LANG', langCode);
    this.setState({langKey: Cookies.get('SELECTED_LANG')});
    location.reload();
  }

  static get(key){
    return (
      languages[Cookies.get('SELECTED_LANG')] ?
      languages[Cookies.get('SELECTED_LANG')][key] :
      languages[ process.muhimma.indexOf(process.target[0]) !== -1 ? 'ar' : 'en' ][key]
    );
  }

  static currentLang() {
    return(Cookies.get('SELECTED_LANG'));
  }

  render() {
    const Key = this.props.get;

    if (Key) {  
      return (
        <span>{ (languages[this.state.langKey]) ? languages[this.state.langKey][Key] : languages[en][Key]}</span>
      )
    } else {
      return (
        <Tooltip
          placement="top"
          overlay={
            <ul className="tooltip-list">
              {
                Object.keys(languageList).map((objectKey, index) => {
                  return(
                    objectKey !== this.state.langKey?
                      <li key={index}>
                        <a onClick={this.switchLang.bind(this, objectKey)} id="live-language-switch-button">
                          {languageList[objectKey]}
                        </a>
                      </li>
                      : ''
                  )
                })
              }
            </ul>
          }
        >
          <div styleName="root">
            <a onClick={this.switchLang.bind(this,this.state.langKey)}>
              <Icon name="flag-o" /> <span>{languageList[this.state.langKey]}</span>
            </a>
          </div>
        </Tooltip>

      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/common/translate.js